import React, { useEffect, useState } from "react";
import { useIntl } from "react-intl";
import Pill from "Components/Pill";
import moment from "moment";
// import { getAbbvTimezone } from "Components/uiControls/Timezone/tools";

export const PillTime = ({
  dateRange,
  format,
  onClick,
  timeFrame,
}) => {
  const { messages, locale } = useIntl();

  let labelFrame = "";
  labelFrame = timeFrame;

  // const timezoneAccount = getAbbvTimezone(timezone)
  let label = messages[`videoMainView_dates_${labelFrame}`];
  const completFormat = `${format}`;
  if (dateRange?.start && dateRange?.end) {
    label = `${label} (${moment(
      dateRange.start
    ).format(completFormat)} - ${moment(
      dateRange.end
    ).format(completFormat)})`;
  }

  return (
    <>
      {
        <Pill
          textField={"label"}
          item={{ label: label }}
          outlined={false}
          style={{ border: "0" }}
          label="pill-label-text"
          colorField="default"
          colorSelection="005bf8"
          onClick={onClick}
        />
      }
    </>
  );
};
